export enum RoutesList {
    BasePrivate = '/private',
    LoginPage = '/public/:lang/login',
    LoginPageCompareValue = 'public/:lang/login',
    HomePage = '/private/:lang/home',
}